.check {
    width: 30px;
    height: 30px;
    max-height: 30px;
    min-height: 30px;
}